import { Box, Row, Tooltip } from "@hightouch/htui";

/**
 * Marks a thread the viewer hasn't caught up on.
 *
 * `inset` pads it out to a small icon button's footprint, for when it sits in a
 * row of them: their glyphs carry their own padding, so a bare dot on the same
 * gap would crowd them. Beside text it wants no such padding.
 */
export const UnreadDot = ({ inset = false }: { inset?: boolean }) => (
  <Tooltip message="Unread">
    <Row align="center" justify="center" boxSize={inset ? 6 : 2} flexShrink={0}>
      <Box
        aria-label="Unread"
        role="img"
        boxSize={2}
        borderRadius="full"
        bg="primary.base"
      />
    </Row>
  </Tooltip>
);
